import * as _ from 'lodash'

let debounced = _.debounce((func, str) =>{
    if(str !== 'abort'){
        func()
    }
}, 5000)

export default debounced